"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var util_1 = require("@aperza/util");
var appConfig = util_1.AppService.appConfig();
var Notification = /** @class */ (function (_super) {
    __extends(Notification, _super);
    function Notification(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            show: true,
        };
        return _this;
    }
    Notification.prototype.onClickClose = function () {
        this.setState({
            show: false,
        });
    };
    Notification.prototype.render = function () {
        // let shouldShow = !appConfig.isAperzaCatalog && appConfig.serviceType!=AppConfig.APERZA_NEWS;
        //let shouldShow = appConfig.isAperzaCatalog || appConfig.isAperzaCatalogTop;
        var shouldShow = [
            util_1.AppConfig.APERZA_SEARCH,
            util_1.AppConfig.APERZA_ID,
            util_1.AppConfig.APERZA_ACCOUNT,
            util_1.AppConfig.APERZA_EC,
            util_1.AppConfig.APERZA_ORDER,
        ].includes(appConfig.serviceType);
        var style = { display: 'none' };
        if (this.state.show && shouldShow) {
            style = {};
        }
        return null; // disable notifications
        // <div className="notification" style={style}>
        //   <ul style={{listStyle: 'none', padding: 0}}>
        //     <li>年末年始休業期間のご案内[12/28（土）～1/5（日）]　≫<a href={'https://www.aperza.com/corp/20191223'} target="_blank">詳細はこちら</a></li>
        //   </ul>
        // </div>
    };
    return Notification;
}(react_1.default.Component));
exports.default = Notification;
